/**
 * 학년 개념이 없는 학교급(대학·유치원·기타)이나 무학년 학교를 골랐을 때,
 * 폼의 필수 검증(z.string().min(1))을 통과시켜 사용자가 제출 불가 상태에
 * 갇히지 않도록 넣는 sentinel. 폼 상태 안에서만 유효한 값이다.
 */
export const NO_GRADE_CODE = 'noGradeCode';

/**
 * 서버는 schoolGradeCode 를 숫자 categoryTreeId 문자열로만 받는다
 * (quiz-server `@ValidCategoryTreeId`). sentinel 이 그대로 올라가면 400 이므로
 * API 요청을 만드는 시점에 반드시 벗겨낸다. 빈 값과 sentinel 모두 미전송 처리.
 */
export const toSchoolGradeCodeReq = (
  code?: string | null,
): string | undefined => (!code || code === NO_GRADE_CODE ? undefined : code);
